module.exports = __webpack_public_path__ + "static/img/img-3.5bbfa1cc.png";